// import React, { useState, useEffect } from 'react';
// import './App.css';
// import { LanguageProvider } from './context/LanguageContext';
// import Navbar from './components/Navbar';
// import Home from './pages/Home';
// import About from './pages/About';
// import Gallery from './pages/Gallery';
// import Tenders from './pages/Tenders';
// import Events from './pages/Events';
// import Committee from './pages/Committee';
// import Location from './pages/Location';
// import Donation from './pages/Donation';
// import Contact from './pages/Contact';
// import Download from './pages/download';
// import Darshan from './pages/Darshan';
// import Footer from './components/Footer';

// import YadnyaBooking from './pages/YadnyaBooking';
// import MahaprasadBooking from './pages/MahaprasadBooking';

// import PrivacyPolicy from './pages/Policy';

// // import BannerSplash from './components/BannerSplash';

// function App() {
//   const [currentPage, setCurrentPage] = useState('home');
//   const [showScrollTop, setShowScrollTop] = useState(false);
//   const [showSplash, setShowSplash] = useState(true);

//   useEffect(() => {
//     if (!showSplash) return;

//     const previousOverflow = document.body.style.overflow;
//     document.body.style.overflow = 'hidden';

//     const t = setTimeout(() => setShowSplash(false), 1800);
//     return () => {
//       clearTimeout(t);
//       document.body.style.overflow = previousOverflow;
//     };
//   }, [showSplash]);

//   useEffect(() => {
//     const handleScroll = () => {
//       setShowScrollTop(window.pageYOffset > 300);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   const renderPage = () => {
//     switch (currentPage) {
//       case 'home': return <Home setCurrentPage={setCurrentPage} />;
//       case 'about': return <About />;
//       case 'gallery': return <Gallery />;
//       case 'tenders': return <Tenders />;
//       case 'events': return <Events setCurrentPage={setCurrentPage} />;
//       case 'committee': return <Committee />;
//       case 'location': return <Location />;
//       case 'darshan': return <Darshan />;
//       case 'aaras-download': return <Download />;
//       case 'donation': return <Donation />;
//       case 'contact': return <Contact />;

//   case 'YadnyaBooking': return <YadnyaBooking />;
//   case 'MahaprasadBooking': return <MahaprasadBooking />;

//   case 'privacy-policy' : return <PrivacyPolicy />;


//       default: return <Home setCurrentPage={setCurrentPage}/>;
//     }
//   };

//   return (
//     <LanguageProvider>
//       <div className="App">
//         {/* Crimson banner splash — only on first home page load */}
//         {/* {showSplash && currentPage === 'home' && <BannerSplash />} */}
//         {showSplash && (
//           <div className="app-splash" role="status" aria-label="Loading">
//             <img
//               src="/Assets/Logo5.png"
//               alt="Shrinath Mhaskoba Mandir"
//               className="app-splash__logo"
//               loading="eager"
//               decoding="async"
//             />
//           </div>
//         )}
//         <Navbar currentPage={currentPage} setCurrentPage={setCurrentPage} />
//         <main>
//           {renderPage()}
//         </main>
//         <Footer setCurrentPage={setCurrentPage} />

//         {/* {showScrollTop && (
//           <button className="scroll-to-top" onClick={scrollToTop}>
//             ↑
//           </button>
//         )} */}
//       </div>
//     </LanguageProvider>
//   );
// }

// export default App;













import React, { useState, useEffect } from 'react';
import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Tenders from './pages/Tenders';
import Events from './pages/Events';
import Committee from './pages/Committee';
import Location from './pages/Location';
import Donation from './pages/Donation';
import Contact from './pages/Contact';
import Download from './pages/download';
import Darshan from './pages/Darshan';
import Footer from './components/Footer';

import YadnyaBooking from './pages/YadnyaBooking';
import MahaprasadBooking from './pages/MahaprasadBooking';
import PrivacyPolicy from './pages/Policy';   // ← Your Privacy Policy component

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [showSplash, setShowSplash] = useState(true);

  // ✅ Automatically detect URL and show correct page
  // useEffect(() => {
  //   const path = window.location.pathname.replace('/', '') || 'home';

  //   const pageMap = {
  //     'privacy-policy': 'privacy-policy',
  //     'policy': 'privacy-policy',
  //     'home': 'home',
  //     'about': 'about',
  //     'gallery': 'gallery',
  //     'tenders': 'tenders',
  //     'events': 'events',
  //     'committee': 'committee',
  //     'location': 'location',
  //     'darshan': 'darshan',
  //     'aaras-download': 'aaras-download',
  //     'donation': 'donation',
  //     'contact': 'contact',
  //     'YadnyaBooking': 'YadnyaBooking',
  //     'MahaprasadBooking': 'MahaprasadBooking',
  //   };

  //   const mappedPage = pageMap[path] || 'home';
  //   setCurrentPage(mappedPage);
  // }, []);


    useEffect(() => {
    if (!showSplash) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const t = setTimeout(() => setShowSplash(false), 1800);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = previousOverflow;
    };
  }, [showSplash]);



  useEffect(() => {
  const path = window.location.pathname.replace('/', '') || 'home';
  const pageMap = {
    'privacy-policy': 'privacy-policy',
    'home': 'home',
    'about': 'about',
    'gallery': 'gallery',
    'tenders': 'tenders',
    'events': 'events',
    'committee': 'committee',
    'location': 'location',
    'darshan': 'darshan',
    'aaras-download': 'aaras-download',
    'donation': 'donation',
    'contact': 'contact',
    'YadnyaBooking': 'YadnyaBooking',
    'MahaprasadBooking': 'MahaprasadBooking',
  };
  setCurrentPage(pageMap[path] || 'home');

  // ✅ हे add करा — browser back/forward काम करेल
  const handlePop = () => {
    const p = window.location.pathname.replace('/', '') || 'home';
    setCurrentPage(pageMap[p] || 'home');
  };
  window.addEventListener('popstate', handlePop);
  return () => window.removeEventListener('popstate', handlePop);
}, []);

  const renderPage = () => {
    switch (currentPage) {
      case 'home': return <Home setCurrentPage={setCurrentPage} />;
      case 'about': return <About />;
      case 'gallery': return <Gallery />;
      case 'tenders': return <Tenders />;
      case 'events': return <Events setCurrentPage={setCurrentPage} />;
      case 'committee': return <Committee />;
      case 'location': return <Location />;
      case 'darshan': return <Darshan />;
      case 'aaras-download': return <Download />;
      case 'donation': return <Donation />;
      case 'contact': return <Contact />;

      case 'YadnyaBooking': return <YadnyaBooking />;
      case 'MahaprasadBooking': return <MahaprasadBooking />;

      // ✅ Privacy Policy Page
      case 'privacy-policy': 
        return <PrivacyPolicy />;

      default: 
        return <Home setCurrentPage={setCurrentPage} />;
    }
  };

  return (
    <LanguageProvider>
      <div className="App">



         {showSplash && (
          <div className="app-splash" role="status" aria-label="Loading">
            <img
              src="/Assets/Logo5.png"
              alt="Shrinath Mhaskoba Mandir"
              className="app-splash__logo"
              loading="eager"
              decoding="async"
            />
          </div>
        )}


        <Navbar currentPage={currentPage} setCurrentPage={setCurrentPage} />
        <main>
          {renderPage()}
        </main>
        <Footer setCurrentPage={setCurrentPage} />
      </div>
    </LanguageProvider>
  );
}

export default App;